import React from 'react';

export const CalendarIcon: React.FC = () => {
  return (
    <svg
      width='25'
      height='18'
      viewBox='0 0 17 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.14679 0C4.72346 0 4.36697 0.356488 4.36697 0.779817V1.11402H3.00786C1.35911 1.11402 0 2.47313 0 4.12189V14.772C0 16.4207 1.35911 17.7798 3.00786 17.7798H13.9921C15.6409 17.7798 17 16.4207 17 14.772V4.12189C17 2.47313 15.6409 1.11402 13.9921 1.11402H12.633V0.779817C12.633 0.356488 12.2765 0 11.8532 0C11.4299 0 11.0734 0.356488 11.0734 0.779817V1.11402H5.92661V0.779817C5.92661 0.356488 5.5924 0 5.14679 0ZM14.0144 16.2425H3.00786C2.20577 16.2425 1.55963 15.5963 1.55963 14.7942V7.15203H15.4404V14.772C15.4626 15.5963 14.8165 16.2425 14.0144 16.2425ZM11.0957 2.67366V3.00786C11.0957 3.43119 11.4522 3.78768 11.8755 3.78768C12.2988 3.78768 12.6553 3.43119 12.6553 3.00786V2.67366H14.0144C14.8165 2.67366 15.4626 3.31979 15.4626 4.12189V5.5924H1.55963V4.12189C1.55963 3.31979 2.20577 2.67366 3.00786 2.67366H4.36697V3.00786C4.36697 3.43119 4.72346 3.78768 5.14679 3.78768C5.57012 3.78768 5.92661 3.43119 5.92661 3.00786V2.67366H11.0957Z'
        fill='#FF0000'
      />
      <rect x='3.5' y='8.7793' width='2' height='2' fill='#FF0000' />
      <rect x='3.5' y='8.7793' width='2' height='2' fill='#FF0000' />
      <rect x='3.5' y='8.7793' width='2' height='2' fill='#FF0000' />
      <rect x='7.5' y='8.7793' width='2' height='2' fill='#FF0000' />
      <rect x='7.5' y='8.7793' width='2' height='2' fill='#FF0000' />
      <rect x='7.5' y='8.7793' width='2' height='2' fill='#FF0000' />
      <rect x='11.5' y='8.7793' width='2' height='2' fill='#FF0000' />
      <rect x='11.5' y='8.7793' width='2' height='2' fill='#FF0000' />
      <rect x='11.5' y='8.7793' width='2' height='2' fill='#FF0000' />
      <rect x='3.5' y='12.7793' width='2' height='2' fill='#FF0000' />
      <rect x='3.5' y='12.7793' width='2' height='2' fill='#FF0000' />
      <rect x='3.5' y='12.7793' width='2' height='2' fill='#FF0000' />
      <rect x='7.5' y='12.7793' width='2' height='2' fill='#FF0000' />
      <rect x='7.5' y='12.7793' width='2' height='2' fill='#FF0000' />
      <rect x='7.5' y='12.7793' width='2' height='2' fill='#FF0000' />
      <rect x='11.5' y='12.7793' width='2' height='2' fill='#FF0000' />
      <rect x='11.5' y='12.7793' width='2' height='2' fill='#FF0000' />
      <rect x='11.5' y='12.7793' width='2' height='2' fill='#FF0000' />
    </svg>
  );
};
